import { createMemo } from "solid-js"
import { EngineMode } from "../../lib/core/engine/EngineMode/EngineMode.enum"
import { useEngineModeSignal } from "../signal/useEngineModeSignal"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const useIsEngineModeMapPreviewMemo = createSharedCachedFactory((engine) => {
  const [getEngineMode] = useEngineModeSignal(engine)

  const memo = createMemo(() => {
    return (getEngineMode() & EngineMode.MapPreview) === EngineMode.MapPreview
  })

  return memo
})
